import { call, put } from 'redux-saga/effects';
import GetListLeaveActions from '../redux/GetListLeaveRedux';
import { api } from './api';

export function* getListLeaves(action: any): Generator<any, void, any> {
  const { children_id, page } = action;
  console.log("children_id", children_id);
  const response = yield call(api.getListLeaves, children_id, page);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetListLeaveActions.getListLeaveSuccess(response.data));
  } else {
    yield put(GetListLeaveActions.getListLeaveFailure());
  }
}